import { Box, Text } from '@chakra-ui/react'
import type { InsuranceParamsDto as Step1FormValues } from 'BrokerTsLib/src/dtos'
import { formatPerson, formatVehicle } from 'BrokerTsLib/src/dtos'
import React from 'react'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'


export const InsuranceInfoDetailsVehicle = (data: Step1FormValues) => {
  const ph = formatPerson(data?.policyHolder?.person)
  const vehicle = formatVehicle(data?.vehicle)

  const vehicleAdditionalData = []
  if (data?.vehicle?.vin)
    vehicleAdditionalData.push(`VIN: ${data.vehicle.vin}`)
  if (data?.vehicle?.licensePlate)
    vehicleAdditionalData.push(`SPZ: ${data.vehicle.licensePlate.toUpperCase()}`)
  if (data?.vehicle?.price)
    vehicleAdditionalData.push(`Hodnota vozidla: ${priceFormat(data.vehicle.price)}`)

  return (
    <Box sx={{ gridArea: 'details', fontSize: 'sm' }}>
      {ph.length > 0 && <Text sx={{ fontWeight: 'medium' }}>{ph}</Text>}
      {vehicle.length > 0 && (<Text sx={{ fontWeight: 'medium' }}>{vehicle}</Text>)}
      {vehicleAdditionalData.length > 0 && <Text>{vehicleAdditionalData.join(', ')}</Text>}
    </Box>
  )
}
